import { Box, Typography } from '@mui/material'
import React from 'react'

export interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
  style?: any
}

export function TabPanel (props: TabPanelProps): JSX.Element {
  const { children, value, index, ...other } = props

  return (
    <React.StrictMode>
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3, padding: '0px' }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    </React.StrictMode>
  )
}

export function a11yProps (index: number): any {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  }
}
